import { render, staticRenderFns } from "./ASC_FindingSummaryDX.vue?vue&type=template&id=19521996&scoped=true&"
import script from "./ASC_FindingSummaryDX.vue?vue&type=script&lang=js&"
export * from "./ASC_FindingSummaryDX.vue?vue&type=script&lang=js&"
import style0 from "./ASC_FindingSummaryDX.vue?vue&type=style&index=0&id=19521996&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19521996",
  null
  
)

export default component.exports